import React, { useEffect, useState, useMemo, memo } from "react";
import "../styles/ProductCategoryPage.css";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO.js";
import marbleDB from "../Data/marble_database.json";

/* ---------- Skeleton Loader ---------- */
const SkeletonGrid = ({ cols = 3, rows = 2 }) => (
  <div className="product-grid" aria-busy="true">
    {Array.from({ length: cols * rows }).map((_, i) => (
      <div className="product-card skeleton" key={i}>
        <div className="skeleton-img" />
        <div className="skeleton-text" />
        <div className="skeleton-btn" />
      </div>
    ))}
  </div>
);

/* ---------- Product Card ---------- */
const ProductCard = memo(({ product, onView }) => {
  const { slug, name, images } = product;

  return (
    <article className="product-card" role="listitem">
      <img
        src={images?.[0] || "/assets/placeholder-product.webp"}
        alt={`${name} Marble Slab at Square Feet Marble Kishangarh`}
        className="product-image"
        loading="lazy"
        decoding="async"
        width="600"
        height="450"
      />

      <h3 className="product-name">{name}</h3>

    <button
  className="view-details-btn"
  onClick={() => onView(slug)}
  aria-label={`View details of ${name}`}
>
  View Details
</button>

    </article>
  );
});

/* ---------- MAIN COMPONENT ---------- */
const ProductCategoryPage = ({
  category,
  seoTitle,
  seoDescription,
  canonical,
  introText
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate loading (UX consistency)
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, []);

  const products = useMemo(() => {
    return marbleDB
      .filter((p) => p.primary === category)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [category]);

  const handleView = (id) => {
    navigate(`/imported-marble/${id}`);
  };

  const categoryTitle =
    category.charAt(0).toUpperCase() + category.slice(1);

  return (
    <>
      <SEO
        title={seoTitle}
        description={seoDescription}
        canonical={canonical}
      />

      <main className="products-page-container">
        <header className="products-header">
          <h1 className="main-heading">
            {categoryTitle} Imported & Italian Marble Collection
          </h1>

          <p className="subheading">
            {introText ||
              `Explore premium ${categoryTitle.toLowerCase()} imported and Italian marble slabs for luxury interiors across India.`}
          </p>
        </header>

        {loading && <SkeletonGrid />}

        {!loading && (
          <section className="product-section">
            <h2 className="category-heading">
              {categoryTitle} Marble Lots
            </h2>

            <div className="product-grid" role="list">
              {products.map((p) => (
                <ProductCard
                  key={p.id}
                  product={p}
                  onView={handleView}
                />
              ))}
            </div>
          </section>
        )}
      </main>
    </>
  );
};

export default ProductCategoryPage;
